import moment from "moment";
import {DATE_FORM_FORMAT} from "@/constants/date";

export const defaultFilters = () => ({
  partner: null,
  streams: [],
  countries: [],
  advertisers: [],
  traffic_sources: [],
  date: moment().startOf('month').format(DATE_FORM_FORMAT),
  ftd: null,
  clientOptions: {
    showNoSpendRows: 0
  }
})